interface Config {
    environment: string;
    websiteUrl: string;
    appInsightsConnectionString: string;
    contactUsEmail: string;
    emailServiceId: string;
    emailTemplateId: string;
    emailTemplateIdAutoreply: string;
    emailPublicKey: string;
    googleAnalyticsMeasurementId: string;
}

const config: Config = {
    environment: import.meta.env.VITE_REACT_ENV || '',
    websiteUrl: import.meta.env.VITE_WEBSITE_URL || '',
    appInsightsConnectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING || '',
    contactUsEmail: import.meta.env.VITE_CONTACTUS_EMAIL || '',
    emailServiceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || '',
    emailTemplateId: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || '',
    emailTemplateIdAutoreply: import.meta.env.VITE_EMAILJS_TEMPLATE_ID_AUTOREPLY || '',
    emailPublicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || '',
    googleAnalyticsMeasurementId: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID || '',
};

export default config;